import VGFlipList from "./nav/VGFlipList";
import {listener} from "../../functions";

function initVGNav() {
	[...document.querySelectorAll('.vg-nav')].forEach((el) => {
		vg.VGNav.init(el, {
			breakpoint: 'lg',
			hover: true,
			collapse: false,
			callback: {
				afterInit: function () {
					setFlipEffect();
				}
			}
		});
	});
}

listener('click', '[data-toggle="click-nav"]', function (el) {
	let container = el.closest('.vg-sidebar');
	new vg.VGSidebar(container).hide();
});

function setFlipEffect() {
	const $elmSidebar = document.getElementById('sidebar-main-nav');
	if ($elmSidebar) {
		let $_navigation = $elmSidebar.querySelector('.vg-nav-wrapper');
		if ($_navigation) {
			let arrSimple = [...$_navigation.querySelectorAll('.dropdown > a')],
				arrMega = [...$_navigation.querySelectorAll('.dropdown-mega > a')];

			$_navigation.classList.remove('vg-nav-wrapper');

			new VGFlipList($_navigation, {target: arrSimple.concat(arrMega)});
		}
	}
}


export default initVGNav;
